/**
 * Member UI copy for Intuto-backed courses and collection-linked courses.
 */
export function shouldUseMemberLearningRegistrationCopy(event: {
  isCourseWorkshop?: boolean | null;
  intutoCourseCollection?: { collectionId?: number | null } | null;
}): boolean {
  if (event.isCourseWorkshop === true) {
    return true;
  }
  const collectionId = event.intutoCourseCollection?.collectionId;
  return typeof collectionId === 'number' && Number.isFinite(collectionId);
}
